import WINDOW from "../../../../utils/window";
import getDeltaPercents from "./get-delta-percents";

/**
 * Delta percents
 * @param {TriggerProps} trigger
 * @param {"x" | "y" | "both"} axis
 * @returns {Number}
 */
const getDelta = (trigger, axis) => {
  /** Default delta amount */
  const defaultAmount = 20;

  const type = /** @type {"scroll" | "pointer"} */ (trigger.get("type"));
  const event = /** @type {WindowCoordinatesProps} */ (WINDOW.get(type));
  const data = /** @type {TriggerParameterComputedDataProps} */ (
    trigger.get("p_method-data")
  );
  const values = data.get("values");
  const amount = values ? values[0] : defaultAmount;
  const specification = 500 / amount;

  switch (axis) {
    case "x": {
      return getDeltaPercents(event, "x", specification);
    }

    case "y": {
      return getDeltaPercents(event, "y", specification);
    }

    default: {
      const x = getDeltaPercents(event, "x", specification);
      const y = getDeltaPercents(event, "y", specification);
      return (x + y) / 2;
    }
  }
};

export default getDelta;
